import { render, staticRenderFns } from "./EditorV2.vue?vue&type=template&id=d893bce4"
import script from "./EditorV2.vue?vue&type=script&lang=js"
export * from "./EditorV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports